import WithSystemDownCheckRoute from './WithSystemDownCheckRoute';

export default WithSystemDownCheckRoute;
